/* eslint-disable import/extensions */
import ViewMessages from "./view-messages.js";
import BlockUI from "./block-ui.js";
import MultiPageRegisterForm from "./multi-page-register-form.js";
import Schedule from "./schedule.js";
import AppointmentConfirmation from "./appointment-confirmation";
import CustomerConfig from "./customer-config";
import Resizer from "./resizer.js";
import Scroller from "./scroller.js";
import PageRouter from "./page-router.js";

window.customerConfig = null;
window.resizer = null;
window.scroller = null;

window.setStyle = (css) => {
  $(() => {
    const $style = $(`<style></style>`);
    $style.text(css);

    $("head").append($style);
  });
}

window.displayViewMessages = (messages, selector) => {
  $(() => {
    const vm = new ViewMessages();
    vm.parse(messages);

    if (!vm.empty) {
      selector = selector ?? "body";
      const $container = $(selector);
      vm.display($container);
      vm.scrollTo();
    }
  })
}

window.clearViewMessages = (selector) => {
  const vm = new ViewMessages();
  selector = selector ?? "body";
  const $container = $(selector);
  vm.clear($container);
}

window.initCommon = (config) => {
  $(() => {
    window.customerConfig = new CustomerConfig(config);

    // Apply config settings

    if (window.customerConfig.hideLogo) {
      $(".logo-wrap").addClass("hidden");
    } else {
      $(".logo-wrap").removeClass("hidden");
    }

    window.resizer = new Resizer();
    window.resizer.init();

    window.scroller = new Scroller(config.disableScrolling);

    // Messages are attached to the body on page load
    window.displayViewMessages($("body").attr("data-messages"));
  });
};

window.initPageRouter = (page, options) => {
  $(async () => {
    window.pageOptions = options;
    window.pageRouter = new PageRouter();
    pageRouter.init();
    pageRouter.load(page);
  });
};

window.initLoginNavItem = () => {
  $(() => {
    const $logoffLink = $("a.logoff");
    $logoffLink.off("click").on("click", (e) => {
      e.preventDefault();
      $(".logout-form").first().submit();
    });
  });
};

window.initLoginPage = () => {
  $(() => {
    const $frmLogin = $("#login-form");
    $frmLogin.on("submit", (e) => {
      if (!$frmLogin.valid()) {
        e.preventDefault();
        return;
      }

      BlockUI.blockWithId("login-register", "Authenticating...");
    });
  });
};

window.initLoginSuccessPage = () => {
  $(() => {
    $(document).trigger("login-success");
  });
};

window.initRegisterPage = () => {
  $(() => {
    const register = new MultiPageRegisterForm();
    register.init();

    // Scroll to form top when moving between pages
    register.eventTarget.on("next-prev.register-form", (e) => {
      window.scroller.scrollToElemTop(register.form);
    });
  });
};

window.initHomePage = () => {
  $(() => {
    $(".appointments").DataTable({
      lengthChange: false,
      searching: false,
      order: [[0, "desc"]],
      responsive: true,
    });
  });
};

window.initBookPage = async () => {
  $(async () => {
    const schedule = new Schedule(window.pageOptions);
    await schedule.init();
  });
};

window.initAppointmentConfirmationPage = () => {
  $(() => {
    const confirmation = new AppointmentConfirmation();
    confirmation.init();
  });
};
